import Reportes from './Reportes';

export default Reportes;
